import React from "react";
import { TrendingUpIcon, TrendingDownIcon } from "@heroicons/react/solid";

const MetalRateCards = ({ rates, loading }) => {
  const metals = [
    { key: "GOLD", label: "Gold", color: "yellow", icon: "🥇" },
    { key: "SILVER", label: "Silver", color: "gray", icon: "🥈" },
    { key: "PLATINUM", label: "Platinum", color: "purple", icon: "💎" },
  ];

  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
        {metals.map((metal) => (
          <div key={metal.key} className="animate-pulse">
            <div className="bg-gray-200 rounded-lg h-28 sm:h-32"></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
      {metals.map((metal) => {
        const rate = rates?.[metal.key];
        const colorClasses = {
          yellow: "bg-yellow-50 border-yellow-200 text-yellow-900",
          gray: "bg-gray-50 border-gray-200 text-gray-900",
          purple: "bg-purple-50 border-purple-200 text-purple-900",
        };

        return (
          <div
            key={metal.key}
            className={`border-2 rounded-lg p-3 sm:p-4 ${
              colorClasses[metal.color]
            } 
              shadow-md hover:shadow-lg transition-shadow duration-200`}
          >
            <div className="flex justify-between items-start mb-2 sm:mb-3">
              <div className="flex items-center">
                <span className="text-xl sm:text-2xl mr-1 sm:mr-2">
                  {metal.icon}
                </span>
                <h3 className="font-bold text-base sm:text-lg">
                  {metal.label}
                </h3>
              </div>
              {rate?.deviation && (
                <div
                  className={`flex items-center text-xs sm:text-sm ${
                    rate.deviation > 0 ? "text-green-600" : "text-red-600"
                  }`}
                >
                  {rate.deviation > 0 ? (
                    <TrendingUpIcon className="h-3 sm:h-4 w-3 sm:w-4 mr-0.5 sm:mr-1" />
                  ) : (
                    <TrendingDownIcon className="h-3 sm:h-4 w-3 sm:w-4 mr-0.5 sm:mr-1" />
                  )}
                  <span className="font-semibold">
                    {Math.abs(rate.deviation)}%
                  </span>
                </div>
              )}
            </div>

            {rate ? (
              <div className="space-y-1.5 sm:space-y-2">
                <div className="flex justify-between items-center">
                  <span className="text-xs sm:text-sm opacity-75">
                    Base Rate
                  </span>
                  <span className="font-bold text-sm sm:text-base">
                    ₹{rate.baseRate?.toLocaleString("en-IN")}
                    <span className="text-xs">/gm</span>
                  </span>
                </div>
                <div className="flex justify-between items-center text-xs sm:text-sm">
                  <span className="opacity-75">Buy</span>
                  <span className="font-medium">
                    ₹{rate.buyRate?.toLocaleString("en-IN")}
                  </span>
                </div>
                <div className="flex justify-between items-center text-xs sm:text-sm">
                  <span className="opacity-75">Sell</span>
                  <span className="font-medium">
                    ₹{rate.sellRate?.toLocaleString("en-IN")}
                  </span>
                </div>
              </div>
            ) : (
              <div className="text-center py-3 sm:py-4 opacity-50">
                <p className="text-sm">No rate set</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default MetalRateCards;
